

















































































import Vue from 'vue';
import moment from 'moment';
import { dateFormat, datePickerFormat } from '@/constants';
import { required, maxLength } from 'vuelidate/lib/validators';
import { date, dateHelpers } from '@/validations';

import {
  CloseFullscreenWrapper,
  FormValidation,
  DateFormat,
  TriggerRefreshError,
} from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { DatePicker } from '@/components/form-components';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { ExtendMixins } from '@/services';
import { AddReleaseAuthorizationFormModel, MemberARIsResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  confirmBeforeClose: boolean;
  formModel: AddReleaseAuthorizationFormModel;
}


export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  DateFormat,
  TriggerRefreshError,
).extend({
  name: 'UpdateReleaseAuthorization',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      confirmBeforeClose: true,
      formModel: {
        id: '',
        firstName: '',
        lastName: '',
        startDate: '',
        endDate: '',
      },
    };
  },
  beforeMount() {
    this.setARIModel();
    this.constructShowErrorModel('formModel');
  },
  validations: {
    formModel: {
      firstName: {
        required,
        maxLength: maxLength(11),
      },
      lastName: {
        required,
        maxLength: maxLength(24),
      },
    },
  },
  computed: {
    ariDesignees(): MemberARIsResponseModel[] {
      return this.$store.getters.ariDesignees;
    },

    // VALIDATIONS
    firstNameErrors(): string[] {
      const formField = 'formModel.firstName';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-ari_form-error_first-name_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'update-ari_form-error_first-name_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    lastNameErrors(): string[] {
      const formField = 'formModel.lastName';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-ari_form-error_last-name_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'update-ari_form-error_last-name_max-length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    setARIModel(): void {
      const ariObj = this.ariDesignees.find((ari) => {
        return ari.id === this.params.id;
      });
      Object.assign(this.formModel, {
        id: ariObj.id,
        firstName: ariObj.firstName,
        lastName: ariObj.lastName,
        startDate: moment(ariObj.startDate, datePickerFormat).format(dateFormat),
        endDate: moment(ariObj.endDate, datePickerFormat).format(dateFormat),
      });
    },
    constructPayload(): AddReleaseAuthorizationFormModel {
      return {
        id: this.formModel.id,
        firstName: this.formModel.firstName,
        lastName: this.formModel.lastName,
        startDate: moment(this.formModel.startDate, dateFormat).format(datePickerFormat),
        endDate: moment(this.formModel.endDate, dateFormat).format(datePickerFormat),
      };
    },
    updateARIDesignee(): void {
      this.isLoading = true;
      this.$store
        .dispatch('updateARIDesignee', this.constructPayload())
        .then(() => {
          this.refreshARIDesignees();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshARIDesignees(): void {
      this.$store
        .dispatch('getARIDesignees')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'update-ari_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    DatePicker,
  },
});
